import React, {useState} from 'react'
import {createWarehouse} from "../../services/serviceWarehouse";
import {Button, Checkbox, Form, Input, Modal} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const { TextArea } = Input
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}


const WarehouseCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])


    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.warehouseName,
            code: list.warehouseCode,
            description: list.warehouseDescription,
            address: list.warehouseAddress,
            phone: list.warehousePhone,
            representative: list.warehouseRepresentative,
            shareStock: list.shareStock
        }
        createWarehouse(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }
    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Yeni Depo Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => form.submit()}
                            loading={loadings[0]}
                    >Kaydet</Button>,
                    <Button key={'CancelButton'} onClick={() => modalCloser()}>Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >

                    <Form.Item
                        label={'Depo Adı'}
                        name={'warehouseName'}
                        rules={[
                            {required:true, message: 'Depo Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Depo Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Depo Kodu'}
                        name={'warehouseCode'}
                        rules={[
                            {required: true, message: 'Depo Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Depo Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 50, message: 'Depo Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Depo Açıklaması'}
                        name={'warehouseDescription'}
                        rules={[
                            {min:1 , max:1000, message: 'Depo Açıklama Alanı En Az 1 En Fazla 1000 Karakter Olmalıdır'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={'Depo Sorumlusu'}
                        name={'warehouseRepresentative'}
                        rules={[
                            {max: 300, message: 'Depo Sorumlusu Alanı En Fazla 300 Karakter Olmalıdır'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Depo Telefonu'}
                        name={'warehousePhone'}
                        rules={[
                            {max: 20, message: 'Telefon Alanı En Fazla 20 Karakter Olmalıdır'},
                            {pattern: /^\d*$/, message: 'Depo Telefonu Sadece Rakam İçermelidir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Depo Adresi'}
                        name={'warehouseAddress'}
                        rules={[
                            {max: 1000, message: 'Adres Alanı En Fazla 1000 Karakter Olmalıdır'}
                        ]}
                    >
                        <TextArea />
                    </Form.Item>
                    <Form.Item
                        label={'Stok Servis Paylaşımı'}
                        name={'shareStock'}
                        valuePropName="checked"
                        initialValue={false}
                    >
                        <Checkbox />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default WarehouseCreate